import { render } from "./myquestionnaireDescLook.vue?vue&type=template&id=6148add2&scoped=true"
import script from "./myquestionnaireDescLook.vue?vue&type=script&lang=js"
export * from "./myquestionnaireDescLook.vue?vue&type=script&lang=js"

import "./myquestionnaireDescLook.vue?vue&type=style&index=0&id=6148add2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6148add2"]])

export default __exports__